import { Toaster } from 'sonner';

import Navbar from 'components/Navbar';

export default function UserLayout({ children, currentUser }) {
  return (
    <div
      className="
      flex flex-col
      "
    >
      <Toaster richColors position="top-center" className="select-none" />
      <main className="flex-1">
        <Navbar currentUser={currentUser} />
        <div
          className="
          container mx-auto
          p-2 m-3 mt-20
          flex items-center justify-center overflow-hidden
          "
        >
          {children}
        </div>
      </main>
    </div>
  );
}
